<template>
      <ul :class="'simulation-card-list' + setActiveClass()" :id="'simulation-card-' + scenarioId" aria-labelledby="simulation-heading">
        <li class="simulation-card-list-item">
          <p class="description-text">Otrzymujesz na konto:</p>
          <p class="value-text">{{ setFormatAmount() }}</p>
        </li>
        <li class="simulation-card-list-item">
          <p class="description-text">Łączny koszt:</p>
          <p class="value-text">{{ setSimulationCost() }}</p>
        </li>
        <li class="simulation-card-list-item">
          <p class="description-text">Przewidywana spłata: </p>
          <time class="value-text">{{ setRepaymentDateShorter() }}</time>
        </li>
        <li class="simulation-card-list-item">
          <p class="description-text">Na spłatę pobieramy:</p>
          <p class="value-text">{{ dayPercent }}% dziennej sprzedaży</p>
        </li>
      </ul>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { CostCalculatorClass, NumberFormatterClass } from '../../class/calculator.class'
import { DateClass } from '../../class/date.class'
import { CALCULATOR_CONTENT } from '../../const/calculator.const'

export default {
  name: 'SimulationCard',
  props: ['simulation'],
  data () {
    return {
      scenarioId: this.simulation.id,
      amount: this.simulation.amount,
      dayPercent: this.simulation.dayPercent,
      maxAmount: CALCULATOR_CONTENT.amount.max,
      percent: CALCULATOR_CONTENT.amount.percent,
      costAmount: null,
      barBoxHeight: null,
      repaymentTerm: CALCULATOR_CONTENT.dates.startRepaymentTerm,
      repaymentMaxTerm: CALCULATOR_CONTENT.dates.startRepaymentMaxTerm
    }
  },
  computed: {
    ...mapState({
      activeScenario: state => state.scenarios.scenario
    })
  },
  methods: {
    ...mapMutations([
      'SET_SCENARIO_ACTIVE',
      'SET_SCENARIO_AMOUNT',
      'SET_SCENARIO_PERCENT'
    ]),
    setActiveScenario () {
      this.SET_SCENARIO_AMOUNT(this.amount)
      this.SET_SCENARIO_ACTIVE(this.scenarioId)
      this.SET_SCENARIO_PERCENT(this.dayPercent)
      if (window.innerWidth < 992) {
        this.goToScenario()
      }
    },
    goToScenario () {
      const top = this.$parent.$el.nextSibling.offsetTop
      window.scrollTo(0, top)
    },
    setActiveClass () {
      return this.activeScenario === this.scenarioId ? ' activeScenario' : ''
    },
    setRepaymentDateShorter () {
      return DateClass.setYear(1)
    },
    setFormatAmount () {
      return NumberFormatterClass.formatAmount(this.amount)
    },
    setSimulationCost () {
      const cost = new CostCalculatorClass(this.amount, this.percent)
      this.costAmount = cost.cost
      return NumberFormatterClass.formatAmount(cost.cost)
    },
    setScenarioData () {
      this.activeScenario === this.scenarioId && this.SET_SCENARIO_PERCENT(this.dayPercent)
      this.activeScenario === this.scenarioId && this.SET_SCENARIO_AMOUNT(this.amount)
    }
  },
  mounted () {
    this.setScenarioData()
  }
}
</script>
